// Centralized API configuration
// This ensures all API calls use the correct base URL in production

const getApiBaseUrl = () => {
  // Check for environment variable (set in Vercel)
  const envUrl = process.env.REACT_APP_API_BASE_URL;
  
  // Log what we're getting
  console.log('[API Config] Raw REACT_APP_API_BASE_URL:', envUrl);
  console.log('[API Config] NODE_ENV:', process.env.NODE_ENV);
  
  if (envUrl) {
    // If it includes /api, use as-is, otherwise add it
    const url = envUrl.endsWith('/api') ? envUrl : `${envUrl}/api`;
    console.log('[API Config] Using env URL:', url);
    return url;
  }
  
  // Production: same host or known domain
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'fundamentalsignals.com' || hostname === 'www.fundamentalsignals.com') {
      const prodUrl = 'https://api.fundamentalsignals.com/api';
      console.log('[API Config] Detected production domain, using:', prodUrl);
      return prodUrl;
    }
    // Deployed elsewhere (e.g. Railway): use same origin so /api goes to this host (set REACT_APP_API_BASE_URL if your API is on a different URL)
    if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
      const url = window.location.origin + '/api';
      console.log('[API Config] Deployed host, using same origin:', url);
      return url;
    }
  }
  
  // Development fallback: 127.0.0.1 to avoid IPv6 localhost issues on Windows
  const devUrl = 'http://127.0.0.1:8000/api';
  console.log('[API Config] Using development fallback:', devUrl);
  return devUrl;
};

const getApiBaseUrlWithoutPath = () => {
  // For endpoints that need the base without /api
  const envUrl = process.env.REACT_APP_API_BASE_URL;
  
  if (envUrl) {
    // Remove /api if present
    return envUrl.replace(/\/api\/?$/, '');
  }
  
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'fundamentalsignals.com' || hostname === 'www.fundamentalsignals.com')
      return 'https://api.fundamentalsignals.com';
    if (hostname !== 'localhost' && hostname !== '127.0.0.1')
      return window.location.origin;
  }
  return 'http://127.0.0.1:8000';
};

export const API_BASE_URL = getApiBaseUrl();
export const API_BASE_URL_NO_PATH = getApiBaseUrlWithoutPath();

// Final log of resolved values
console.log('[API Config] Final API_BASE_URL:', API_BASE_URL);
console.log('[API Config] Final API_BASE_URL_NO_PATH:', API_BASE_URL_NO_PATH);

